import React from 'react';
import APIService from '../../Service/APIService';
import GenericDashboard from '../GenericDashboard/GenericDashboard';

const ProductLog = () => {
  const [productLogs, setProductLogs] = React.useState([]);

  const getProductLogs = async () => {
    const apiService = new APIService();
    const response = await apiService.getDataFromBackend("account/productlog");

    console.log("response:", response);
    console.log("response:", response?.data);
    return response?.data;
  }

  React.useEffect(() => {
    console.log("Product Log");
    getProductLogs().then((data) => {
      console.log("Product Log Data: ", data);
      setProductLogs(data);
    });
  }, []);

  return (
    <div>
      <h1>Product Log</h1>
      {productLogs && productLogs.length > 0 &&
        <div>
          {/* Working */}
          <GenericDashboard data={productLogs} screen="ProductLog" />

        </div>
      }
    </div>
  )
}

export default ProductLog;